import React from 'react'
import { map } from 'lodash/fp'

import withLoading from '../../utils/withLoading'
import { withNotifier } from '../../containers/Notifications'
import { isEmptyObject } from '../../utils/isEmptyObject'

import Modal from '../Modal'
import { AppContext } from '../App'
import Form from './Form'

const USER_ENDPOINT = '/user/rest/user'

const LazyForm = withLoading(Form)
const decorate = withNotifier

const normalizeUser = (user) => ({
  ...user,
  roleNames: map('name', user.roles),
})

class EditUser extends React.Component {
  static contextType = AppContext
  constructor(props) {
    super(props)
    const user = this.props.user ? normalizeUser(this.props.user) : null

    this.state = {
      user: this.props.user ? user : null,
    }
  }

  componentDidMount() {
    !this.state.user && this.fetchUser()
  }

  editUser = async (values) => {
    try {
      const response = await this.context.withAuth(
        `${USER_ENDPOINT}/${values.id}`,
        {
          method: 'PUT',
          payload: values,
        }
      )
      this.props.notify(
        `Dane uzytkownika o id ${values.id} zostały zmienione`,
        'success'
      )
      response && this.props.handleModalStates('EditUser')
    } catch (e) {
      console.log(e)
    }
  }

  fetchUser = async () => {
    try {
      const {
        model: { roles, ...rest },
      } = await this.context.withAuth(`${USER_ENDPOINT}/${this.props.id}`, {
        method: 'GET',
      })

      const roleNames = map('name', roles)
      this.setState({ user: { ...rest, roleNames } })
    } catch (e) {
      e.status === 409 &&
        this.props.notify(
          'Podany login jest zajęty przez innego użytkownika',
          'error'
        )
    }
  }

  render() {
    return (
      <Modal
        isOpen={!isEmptyObject(this.props.modalReady)}
        title="Edytuj osobę"
      >
        <LazyForm
          ready={!!this.state.user}
          onClose={this.props.onClose}
          initialValues={this.state.user}
          onSubmit={this.editUser}
        />
      </Modal>
    )
  }
}

export default decorate(EditUser)
